import React, { useState } from "react";
import { useFormik } from "formik";
import {
  Box,
  Typography,
  // FormGroup,
  // FormControlLabel,
  Button,
  Stack,
  Divider,
  IconButton,
  InputAdornment,
  InputLabel,
  TextField,
  Grid,
  Alert,
  AlertTitle,
} from "@mui/material";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import * as yup from "yup";

import { useNavigate } from "react-router-dom";

import API, { FrontendURL } from "../APIUrls";
import { apiData } from "../services/api-methods";
import { Carousel } from "react-responsive-carousel";
import couch from "../assests/couch.jpg";
import table from "../assests/table.jpg";
import sofa from "../assests/sofa.jpg";
import Header from "./header";
import Footer from "./footer";

const validationSchema = yup.object({
  email: yup
    .string()
    .email("Enter a valid email")
    .required("Email is required"),

  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters long"),
});

const Login = ({ title, subtext }) => {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        
        const response = await apiData("post", API.login, values);

        if (response.status === true) {
          const payLoad = {
            user: response.data.user,
            token: response.data.token,
          };
          localStorage.setItem("userData", JSON.stringify(payLoad));
          setMessage({ status: "success", msg: "Logged in Successfully" });

          setTimeout(() => {
            window.location.href = FrontendURL + "/enquiry";
          }, 2000);
        } else {
          setMessage({ status: "error", msg: "Invalid username or password" });
          setLoading(false);
        }
      } catch (error) {
        console.error("Login failed:", error);
      }
    },
  });

  // const handleForgotPasswordClick = () => {
  //   navigate("/auth/forgot-password");
  // };

  // useEffect(() => {
  //   const userData = JSON.parse(localStorage.getItem("userData"));
  //   if (userData && userData.token) {
  //     navigate("/enquiry");
  //   }
  // }, []);

  return (
    <div className="main loginMain">
      <div>
        <Header />

        {message && message.status && (
          <Alert severity={`${message.status}`}>
            <AlertTitle>{message.status}</AlertTitle>
            {message.msg && <>{message.msg}</>}
          </Alert>
        )}

        <Grid container spacing={2}>
          <Grid item xs={12} md={12} lg={8}>
            <Carousel
              transitionEffect="fade"
              autoPlay
              infiniteLoop
              showThumbs={false}
            >
              <div>
                <img src={couch} alt=" 1" className="responsive-image" />
              </div>
              <div>
                <img src={table} alt=" 2" className="responsive-image" />
              </div>
              <div>
                <img src={sofa} alt=" 3" className="responsive-image" />
              </div>
            </Carousel>
          </Grid>
          <Grid item xs={12} md={12} lg={4} className="signin">
            <Typography
              fontWeight="700"
              variant="h5"
              mb={1}
              style={{ textAlign: "center", padding: "10px" }}
            >
              Welcome to Kalu Interiors
            </Typography>
            <Box mt={3}>
              <Divider>
                <Typography
                  component="span"
                  color="textSecondary"
                  variant="h6"
                  fontWeight="400"
                  position="relative"
                  px={2}
                >
                  Sign In
                </Typography>
              </Divider>
            </Box>
            <form onSubmit={formik.handleSubmit}>
              <Stack>
                <Box style={{ paddingBottom: "15px" }}>
                  <InputLabel htmlFor="username">Email Id</InputLabel>
                  <TextField
                    // startAdornment={
                    //   <InputAdornment position="start">
                    //     <IconAt size="20" />
                    //   </InputAdornment>
                    // }
                    fullWidth
                    id="email"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                </Box>
                <Box>
                  <InputLabel htmlFor="password">Password</InputLabel>
                  <TextField
                    fullWidth
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.password && Boolean(formik.errors.password)
                    }
                    helperText={
                      formik.touched.password && formik.errors.password
                    }
                    // startAdornment={
                    //   <InputAdornment position="start">
                    //     <IconShieldLock size="20" />
                    //   </InputAdornment>
                    // }
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton onClick={handleTogglePassword} edge="end">
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Box>
                <Stack
                  justifyContent="space-between"
                  direction="row"
                  alignItems="center"
                  my={2}
                >
                  {/* <Typography
                  component="span"
                  fontWeight="500"
                  sx={{
                    textDecoration: "none",
                    color: "primary.main",
                    cursor: "pointer",
                  }}
                  onClick={handleForgotPasswordClick}
                >
                  Forgot Password ?
                </Typography> */}
                </Stack>
              </Stack>
              <Box>
                <Button
                  color="primary"
                  variant="contained"
                  size="large"
                  fullWidth
                  type="submit" // Removed component={Link} to="/" from here
                  disabled={loading}
                >
                  Sign In
                </Button>
              </Box>
            </form>
          </Grid>
        </Grid>
      </div>

      {/* {subtitle} */}
      <Footer />
    </div>
  );
};

export default Login;
